/* eslint-disable no-useless-escape */
// tslint:disable:max-line-length
export const VALIDATION_PATTERNS = {
  SLUG: /^([A-Z0-9\&\.\'])(\s?[A-Z0-9\&\.\'])+(-[A-Z0-9\&\.\'](\s?[A-Z0-9\&\.\'])+){1,4}\/([A-Z0-9\&\.\\ \s\-\']*)(\s?\([A-Z0-9\&]+(,\s[A-Z0-9\&]+)*\))?$/,
  SLUG_WILD: /^[A-Za-z0-9&. \s\-']*(\s?\([A-Z0-9\&]+(,\s[A-Z0-9\&]+)*\))?$/,
  VALID_SLUG_CHARACTERS: /^[A-Z0-9\&\.\'\s-\/\(,\)]*$/,
  ONLY_LATIN: /^[a-zA-Z]+$/,
  UPLOAD_FILE_NAME: /^[0-9a-zA-Z!\-_.*'() ]+$/,
  DATA_FILE_NAME: /^[1-9a-zA-Z\-\._]+$/,
  URL: /^(?:\w+:)?\/\/(\S+)[^\s\.]+\.\S{2,}$/,
  MIME_TYPE: /^([a-zA-Z0-9]+)\/([a-zA-Z0-9.+\-]+)$/,
  VALID_MIME_TYPE_CHARACTERS: /^[a-zA-Z0-9\.\+\-\/]*$/,
  EXTENSION: /^\.[0-9a-zA-Z\$\#\&\%\+\@\!\(\)\-\_\{\}\'\`\ \~\,]+$/,
  EXTENSION_START: /^\..*$/,
  NUMBERS: /^([0-9]+)$/,
  INVALID_SEARCH_CHARACTERS: /[-!^*()+~={}\[\]":><?\/\\]|(&&)|(\|\|)/,
  PACK_PATH: /\/group\/[a-zA-Z]+\/pack\//,
  USER_PREFERENCE_KEY: /^\w+-\w+$/,
  GROUP_PATH: /\/group\/[a-zA-Z]+/,
  GRAPHIC_PATH: /\/graphic\/[a-zA-Z]+/,
  CONSUMER_SEARCH_PATH: /\/consumersearch/,
}

export const AUTH_TOKEN_RE = /\?token=([^&?#\/]+)/
